<script>
  import AppMenu from './Menu.vue';
  import Navbar from './Navbar.vue';
  import PageHeader from './PageHeader.vue';
  import AppFooter from './Footer.vue';
  import VoltarAoTopo from './VoltarAoTopo.vue';
  import ChatBotWidget from './ChatBotWidget.vue';
  import "../js/inspinia";

  export default {
    name: 'layout',
    components: { AppMenu, Navbar, PageHeader, AppFooter, VoltarAoTopo, ChatBotWidget }
  }
</script>

<template>
  <div id="wrapper">
    <app-menu></app-menu>

    <div id="page-wrapper" class="gray-bg">
      <navbar></navbar>
      <page-header></page-header>

      <router-view></router-view>
      
      <app-footer></app-footer>
      
      <voltar-ao-topo></voltar-ao-topo>
      <chat-bot-widget></chat-bot-widget>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/Layout.vue